import { dataService } from 'App';

const infoServiceUrl='/users/templates';

export function getMessageTemplates() {
  return dataService.get(
    `${infoServiceUrl}`,
  );
}


export function deleteMessageTemplate(id) {
  return dataService.post(
    `${infoServiceUrl}/${id}`,
  );
}